import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Kicker, H2 } from './ui/Typography';
const BOOK_MOCKUP_URL = 'https://cdn.shopify.com/s/files/1/0736/0194/1549/files/Screenshot2026-04-26230052.png?v=1777271554';
const BUMP_ENABLED = true;
const BUMP_VARIANT_ID = '44879668052013';
export function OfferSection() {
  const [bumpChecked, setBumpChecked] = useState(false);
  const includes = ['65-page PDF (lifetime access, lifetime updates)', '7 income paths with workflows, prompts, first-client scripts', '30-day launch plan with daily checklists', '100 copy-paste prompts organized by path', '3 printable worksheets (Path Picker, $500 Tracker, 30-Day Tracker)', '"How to Start Monday" bonus checklist'];
  return <Section id="offer" hasOrb={true} className="py-32" data-id="element-123">
      <div className="max-w-5xl mx-auto" data-id="element-124">
        <div className="text-center mb-16" data-id="element-125">
          <div className="flex justify-center" data-id="element-126">
            <Kicker data-id="element-127">GET THE BOOK</Kicker>
          </div>
          <H2 data-id="element-128">ONE TIME. $17. YOURS FOREVER.</H2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-129">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5
        }} className="relative flex items-center justify-center" data-id="element-130">
            <div className="absolute pointer-events-none" style={{
            width: '85%',
            height: '80%',
            background: 'radial-gradient(ellipse, rgba(250,255,0,0.3) 0%, rgba(250,255,0,0.08) 40%, rgba(250,255,0,0) 70%)',
            filter: 'blur(60px)',
            zIndex: 0
          }} data-id="element-131" />
            <img src={BOOK_MOCKUP_URL} alt="The AI Income Blueprint" className="relative z-10 w-full max-w-md h-auto" style={{
            filter: 'drop-shadow(0 40px 80px rgba(0,0,0,0.6))'
          }} data-id="element-132" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5
        }} className="flex flex-col" data-id="element-133">
            <div className="flex items-end gap-4 mb-8" data-id="element-134">
              <span className="text-3xl text-ink-dim line-through decoration-red-500/50" data-id="element-135">$34</span>
              <span className="font-archivo text-6xl text-brand leading-none" data-id="element-136">$17</span>
              <span className="font-mono text-xs text-black bg-brand px-2 py-1 rounded uppercase tracking-wider mb-2" data-id="element-137">
                50% LAUNCH PRICE
              </span>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-138">
              {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-139">
                  <span className="text-brand font-bold mt-1" data-id="element-140">+</span>
                  <span className="text-ink-dim" data-id="element-141">{item}</span>
                </li>)}
            </ul>

            {/* ORDER BUMP */}
            <label className={`block mb-8 rounded-[16px] border-[2px] p-6 cursor-pointer transition-all ${bumpChecked ? 'border-brand bg-[rgba(250,255,0,0.08)]' : 'border-border-strong bg-[rgba(250,255,0,0.03)] hover:bg-[rgba(250,255,0,0.05)]'}`} data-id="element-142">
              <div className="flex items-start gap-4" data-id="element-143">
                <input type="checkbox" checked={bumpChecked} onChange={e => setBumpChecked(e.target.checked)} className="mt-1 w-5 h-5 accent-brand cursor-pointer shrink-0" data-id="element-144" />
                <div data-id="element-145">
                  <div className="font-mono text-brand text-xs uppercase tracking-[0.18em] mb-2" data-id="element-146">
                    // ONE-TIME OFFER
                  </div>
                  <p className="font-bold text-ink mb-2 leading-snug" data-id="element-147">
                    YES — add the <span className="text-brand" data-id="element-148">50 Power Prompts</span> for just +$10{' '}
                    <span className="text-ink-dim font-normal line-through text-sm ml-1" data-id="element-149">(normally $17)</span>
                  </p>
                  <p className="text-sm text-ink-dim leading-relaxed" data-id="element-150">
                    50 deep, production-ready prompts across 10 categories. The companion vault to the Blueprint.
                    Copy, paste, and get results the same day. Only offered at this price right here.
                  </p>
                </div>
              </div>
            </label>

            <Button testId="offer-cta" className="w-full text-xl py-5 mb-6" bumpVariantId={bumpChecked ? BUMP_VARIANT_ID : undefined} data-id="element-151">
              {bumpChecked ? 'GET BLUEPRINT + 50 PROMPTS · $27' : 'GET THE BLUEPRINT · $17'}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-8" data-id="element-152">
              {['INSTANT PDF DOWNLOAD', '30-DAY REFUND', 'SECURE CHECKOUT'].map((badge, i) => <div key={i} className="flex items-center gap-2" data-id="element-153">
                  <span className="text-brand" data-id="element-154">✓</span>
                  <span className="font-mono text-xs text-ink-dim uppercase tracking-wider" data-id="element-155">{badge}</span>
                </div>)}
            </div>

            <div className="text-sm text-ink-dim text-center leading-relaxed bg-[rgba(255,255,255,0.02)] p-6 rounded-[10px] border border-border" data-id="element-156">
              <strong className="text-ink block mb-2" data-id="element-157">The "No-BS" Guarantee</strong>
              If you finish the 30-day plan and don't land a single paying
              client, email me. I'll refund you AND send a 30-minute strategy
              call free. No questions, no form, no hassle.
            </div>
          </motion.div>
        </div>
      </div>
    </Section>;
}